<article class="ul-card narrow">
  <comp-card-header>
    <span headline>{{ 'license.title' | translate }}</span>
  </comp-card-header>
  <p>Please review the license terms before using CRA Companion.</p>
  <div class="license-agreement">
    <p>MASTER LICENSE AND SERVICES AGREEMENT</p>

    <p>
      This Master License and Services Agreement ("MLSA") is effective upon first log-in (“Effective
      Date”) and is entered into by and between UL Method Park Gmbh (“UL Solutions”) and the user’s
      legal entity (“Client”). For purposes of this MLSA, defined terms are set forth in Section 21
      (below), and in all other cases, capitalized terms used but not defined in Section 21 shall
      have the meaning assigned to such term in the applicable section of the MLSA:
    </p>

    <p>
      ORDER FORMS. UL Solutions may provide Services or Software (each, defined below) in accordance
      with the terms of this MLSA, the terms of the Order Form (defined below), and any additional
      terms or conditions provided by UL Solutions that govern such Software or Services
      ("Additional Terms") (collectively, the MLSA, Order Form, and any Additional Terms are
      hereafter, the "Agreement"). If there is any conflict or inconsistency between the terms and
      conditions of this MLSA and those of an Order Form or Additional Terms, the terms of this MLSA
      will prevail, except as otherwise expressly stated in such Order Form or Additional Terms.
    </p>

    <p>
      ACCESS AND/OR LICENSE RIGHTS. Subject to Client's payment to UL Solutions of applicable fees,
      UL Solutions will make the Services available to Client, and grants to Client a non-exclusive,
      non-transferable, non-sublicensable, revocable, limited license to use the Software, for
      Client's internal business purposes in accordance with the terms and conditions of the
      Agreement. Each Order Form will set out the Term (as applicable) and scope of access and use
      of the Software and/or Services. Client is fully responsible for any use of Software and/or
      Services by any Authorized Users.
    </p>

    <p>
      An Order Form may identify the quantity and/or categories of Authorized Users (defined below)
      (such as Client Affiliates or contractors) who may access and use the Software and/or
      Services. At no time may the total number of Authorized Users exceed the quantity set forth in
      the Order Form. If accounts for Authorized Users are granted on a named basis, such accounts
      may not be shared among different individuals.
    </p>

    <p>
      An Order Form may identify a specific quantity of servers or systems (each, a “Server”), in
      which Client may install Software (“Installed Copies”). At no time may the total number of
      Installed Copies exceed the quantity set forth in the Order Form.
    </p>

    <p>
      AFFILIATE ORDERS. Client or any of its Affiliates (each, a “Client Party”) may engage UL
      Solutions or any of its Affiliates (each, a “UL Solutions Party”) to provide Software and/or
      Services under this Agreement by entering into an Order Form that is signed by a Client Party
      and a UL Solutions Party. Each Order Form shall incorporate the terms of this MLSA by
      reference. For purposes of such Order Form, the Client Party entering into the Order Form (the
      “Client Ordering Party”) is solely responsible for any duties or obligations owed to the UL
      Solutions Party that enters into the Order Form (the “Supplier”), including, without
      limitation, the payment of fees for the Software or Services described in such Order Form.
      Likewise the Supplier is solely responsible for any duties and obligations owed to the Client
      Ordering Party, including, without limitation, the performance of the Services or provision of
      Software described in the Order Form. For purposes of such Order Form, references in this
      Agreement to “Client” means the Client Ordering Party identified in the Order Form, and
      references in this Agreement to “UL Solutions” means the Supplier identified in the Order
      Form. Unless a Client Party or UL Solutions Party signs an Order Form in its own capacity,
      neither the Client Party nor the UL Solutions Party has any liability or obligation under the
      Order Form.
    </p>

    <p>FEES, EXPENSES, AND TAXES.</p>

    <p>
      Each Order Form will set out fees payable, expense reimbursement terms, and applicable payment
      terms for the Software and/or Services. Unless otherwise set forth in an Order Form, Client
      will pay UL Solutions promptly upon receipt of the applicable invoice. Except as otherwise set
      forth in the Agreement, all sales of Services and/or Software licenses are non-cancelable and
      all sums paid nonrefundable.
    </p>

    <p>
      The fees for the Software and/or Services are exclusive of any transaction-related tax that
      may apply to such Order Form. Client is responsible for all taxes (including value added taxes
      or withholding taxes), duties or imposts which may be levied by applicable law or by a
      governmental body (“Taxes”) other than taxes measured by a UL Solutions’ net income related to
      such Order Form. UL Solutions may add such Taxes (e.g. value added taxes, if any) to invoices
      and collect them from Client. Client may not deduct any wire or transfer fees or other
      offsets. Client shall make all payments to be made by it to UL Solutions without any deduction
      of Taxes, unless such a Tax deduction is required by law. If a Tax deduction is required by
      law to be made by Client, the amount of the payment due from Client shall be increased to an
      amount which (after making any Tax deduction) leaves an amount equal to the payment which
      would have been due if no Tax deduction had been required. Client shall use reasonable efforts
      to provide UL Solutions with all information and documents about such Tax deduction,
      including, but not limited to the obtaining of an official receipt issued by the respective
      governmental body which reflects the actual amount of Taxes withheld.
    </p>

    <p>
      If Client fails to pay any amounts when due, UL Solutions may suspend access to the Software
      and/or Services until such amounts are paid. Client acknowledges that Software and/or Services
      may include a timing mechanism that causes it to cease functioning if Client has not renewed
      the Term prior to its expiration. In case Client is in default with payment, Client will
      promptly reimburse UL Solutions for all reasonable costs and expenses (including reasonable
      attorneys’ fees) incurred by UL Solutions in connection with collecting any payments (or
      portion of payments) to UL Solutions with which the Client is in default. Any other rights of
      UL Solutions, including to claim interest and/or damages in accordance with applicable
      statutory law, remain unaffected.
    </p>

    <p>CLIENT RESPONSIBILITIES AND PERMITTED USE.</p>

    <p>
      UL Solutions will determine how the Services are performed, subject to the specifications set
      out in each Agreement. Client will: (i) designate appropriate resources and cooperate with UL
      Solutions to support timely provision of Software or Services; (ii) keep its own systems,
      computer hardware, and software compatible with any Software or Service specifications; and
      (iii) promptly notify UL Solutions of any unauthorized access to or use of Client’s account.
      Client acknowledges it is responsible for keeping its passwords and account information
      strictly confidential and for all acts that occur if it fails to do so. Aside from those
      rights expressly granted herein, Client has no rights in or to the provided Software or
      Services.
    </p>

    <p>
      To the fullest extent permitted under applicable law, Client will not directly or indirectly:
      sell, resell, transfer or distribute (or redistribute) the Software and/or Services; rent,
      lease, sublicense the Software and/or Services, use the Software and/or Service as a service
      bureau, or otherwise make available the Software and/or Services for use by anyone other than
      an Authorized User; copy (except for disaster recovery purposes), adapt, modify (except as
      expressly permitted by UL Solutions in writing), and/or create derivative works from, the
      Software and/or Services or any component thereof, or otherwise copy the look and feel,
      functionality, or user interface of any portion of the Software and/or Services; remove,
      alter, or obscure any copyright, trademark, confidentiality, or other proprietary notices,
      labels, or marks from or on the Software and/or Services; engage in a denial of service,
      overload or flood any system, or similar activity, upload any malware, virus, or malicious
      code, or interfere with or disrupt UL Solutions’ ability to provide the Software and/or
      Services; perform penetration, vulnerability, or similar testing or defeat, disable, or
      circumvent any protection mechanism of the Software and/or Services; decompile, disassemble,
      reverse engineer, or in any way derive source code from any portion of the Software and/or
      Services; create any links on any publicly accessible internet site to, or frame or mirror,
      the Software and/or Service or any portion thereof; or use the Software and/or Service in
      violation of applicable law or use the Software and/or Service in a manner other than as
      permitted in the Agreement or applicable documentation provided by UL Solutions.
    </p>

    <p>INTELLECTUAL PROPERTY AND OWNERSHIP.</p>

    <p>
      UL Solutions Ownership Rights. The Software and Services and all IP Rights therein are and
      shall remain the sole and exclusive property of UL Solutions and its licensors, as applicable.
      Except for the limited license granted in Section 2, Client will have no rights, title, or
      interest in or to the Software or Services.
    </p>

    <p>
      Client Ownership Rights. As between Client and UL Solutions, the data, text, images, audio and
      videos that Client (or its Authorized Users, licensors or other third parties acting on its
      behalf) submit or enter into the Software and/or Services (collectively, “Client Content”) are
      and will remain the sole and exclusive property of Client. Client grants to UL Solutions and
      its Affiliates the non-exclusive right to use, reproduce, distribute, make available, display,
      process and transmit Client Content to provide the Services and Software pursuant to and in
      accordance with this Agreement. Client is solely responsible for the accuracy of Client
      Content and for obtaining all rights related to Client Content required by UL Solutions to
      perform the Services. Except for the limited rights set forth in this Agreement, UL Solutions
      has no rights, title, or interest in or to Client Content.
    </p>

    <p>
      Feedback License. Client grants to UL Solutions and its Affiliates a worldwide, perpetual,
      irrevocable, royalty-free, transferable and sub-licensable non-exclusive license, to use,
      reproduce, distribute, make available, communicate, edit, process and incorporate into its
      Services or Software, for purposes of product improvement and development any suggestions,
      ideas, enhancement requests, feedback, or recommendations provided by or on behalf of Client
      relating to the operation or performance of the Services and/or Software (including feedback
      that may be provided via a feedback widget that may be made available on a UL Solutions’
      website) (“Feedback”). Client agrees that Feedback shall not include any Client Confidential
      Information.
    </p>

    <p>
      Usage Metrics. UL Solutions may collect and use Usage Metrics (defined below) to operate its
      business, including to support Client’s account and support, improve, and enhance the Software
      and/or Services, and to market services to Client and its Authorized Users in accordance with
      Client’s and its Authorized Users’ marketing preferences. “Usage Metrics” means information
      about the usage of, or interaction with, the Software or Services by Authorized Users,
      including but not limited to usage metrics and performance data, such as data generated
      automatically from the Software or Service infrastructure itself (for example, screen
      resolution, device type, and the duration of a page visit).
    </p>

    <p>
      Aggregated Data. UL Solutions may collect and use Aggregated Data (defined below) to improve
      UL Solutions products or services, develop new products, understand and/or analyze usage,
      demand, and general industry trends, develop and publish analytics, benchmarks and white
      papers summarizing the foregoing, and for other purposes related to UL Solutions’ business.
      “Aggregated Data” means aggregated and anonymized Client Content derived from the Software or
      Services that no longer identifies Client or Authorized Users. Aggregated Data does not
      contain any Personal Data (as defined in Exhibit A (Personal Data Processing Terms)). The
      Aggregated Data and Usage Metrics will not be considered Client Content.
    </p>

    <p>CONFIDENTIALITY.</p>

    <p>
      The parties acknowledge that for purposes of performing under this Agreement, they may receive
      or have access to (such party being a “Recipient”) certain information and materials
      concerning the other party’s or its Affiliates’ (such party being a “Discloser”) business,
      technology, and/or products (including the Services, Client Content, and all terms and
      conditions and pricing set forth in this Agreement) that are confidential and of substantial
      value to the other party, which value would be impaired if such information were disclosed to
      third parties (“Confidential Information”). Confidential Information includes, but is not
      limited to, trade secrets within the meaning of the German Act on the Protection of Trade
      Secrets. The Recipient agrees to maintain the Confidential Information of the Discloser in
      confidence and not to use any such Confidential Information for any purpose other than in
      furtherance of the Agreement purposes and the activities described herein. Recipient must
      protect the confidentiality of the Discloser’s Confidential Information using a standard of
      care at least equal to that which it applies to safeguard its own confidential information,
      and in no event less than a reasonable standard of care. Recipient may only disclose
      Confidential Information to the employees, officers, directors, agents, suppliers or
      contractors of Recipient or its Affiliates who (i) have a reasonable need for access to such
      Confidential Information and (ii) are bound by obligations to protect such Confidential
      Information that are at least as restrictive as those set forth herein.
    </p>

    <p>
      The obligations under Section 7.1 will not apply to any Confidential Information which: (a) is
      now or thereafter becomes generally known or available to the public, through no act or
      omission on the part of Recipient or any third party subject to any use or disclosure
      restrictions with respect to such Confidential Information; (b) was known by or lawfully in
      the possession of Recipient prior to receiving such information from Discloser, without
      restriction as to use or disclosure; (c) is rightfully acquired by Recipient from a third
      party who has the right to disclose it and who provides it without restriction as to use or
      disclosure; or (d) is independently developed by Recipient without access to any Confidential
      Information of Discloser. In addition, the obligations under Section 7.1 will not restrict
      Recipient from disclosing Discloser’s Confidential Information to the extent required by any
      law or regulation or compelled by a court or administrative agency of competent jurisdiction;
      provided that, to the extent permitted by applicable law, Recipient uses reasonable efforts to
      give Discloser reasonable advance notice of such required disclosure in order to enable
      Discloser to prevent or limit disclosure.
    </p>

    <p>
      Upon expiration or termination of the Agreement, Recipient will promptly delete, or return
      upon request, all documents and information, however recorded, which contain Discloser’s
      Confidential Information; provided that Recipient will be permitted to maintain copies in an
      archived computer system backup that was made in accordance with its corporate business
      continuity or disaster recovery procedures. UL Solutions will make Client Content available to
      Client upon request, in a format agreed by UL Solutions, at UL Solutions current professional
      services rates.
    </p>

    <p>
      Client is prohibited from obtaining UL Solution’s Confidential Information by means of reverse
      engineering, including any re-development, decompiliation, disassembly, testing and/or
      examination with the aim of obtaining Confidential Information not intended to be disclosed to
      Client. Any other rights and obligations of the parties under the German Act on the Protection
      of Trade Secrets remain unaffected.C
    </p>

    <p>
      DATA PRIVACY. To the extent Client enters into, or submits to, the Services any Client Content
      containing Personal Data (“Client Personal Data”) that UL Solutions processes on behalf of
      Client, UL Solutions agrees to process such Client Personal Data in accordance with the
      “Personal Data Processing Terms” attached as Exhibit A (Personal Data Processing Terms). For
      the avoidance of doubt, the following types of Personal Data will not be subject to the
      Personal Data Processing Terms: (i) Personal Data relating to business contacts exchanged
      between the parties in the context of the general business relationship, such as for account
      administration, billing, and other legitimate business purposes, (ii) Personal Data provided
      by Authorized Users (about such Authorized Users) directly to UL Solutions via the Software,
      Services, and/or a related UL Solutions internet site, such as user account or contact
      information (i.e., name and/or email address) in accordance with UL Solutions’ applicable
      privacy notice posted on such internet site, and (iii) Usage Metrics collected or generated by
      the Software, Services and/or UL Solutions internet site. The types of Personal Data described
      in the preceding sentence will each be Processed by UL Solutions as a “Controller” in
      accordance with applicable Data Protection Legislation and UL Solutions’ applicable privacy
      notice posted on such Software, Services and/or UL Solutions internet site or otherwise made
      available to Client. Any capitalized terms used in this Section not defined in the MLSA have
      the meanings as defined in the Personal Data Processor Terms.
    </p>

    <p>Undertakings.</p>

    <p>UL solutions Undertakings.</p>

    <p>
      General Undertaking. UL Solutions undertakes to Client that it has full power and authority to
      enter into this MLSA and each Agreement and it will comply with all applicable laws and
      regulations in the performance of its obligations hereunder.
    </p>

    <p>
      Specifications and Defects of Services. UL Solutions undertakes to Client that during the Term
      it will provide Services with reasonable skill and care and in accordance with the applicable
      specifications in each Agreement. If the Services provided to Client were not performed as
      agreed and/or in case of defects of the Services, Client must promptly provide UL Solutions
      with written notice that describes the deficiency in the Services.
    </p>

    <p>
      Specifications and Defects of Software. UL Solutions undertakes that the Software shall
      conform to the applicable specifications in each Agreement. In case of a defect of the
      Software, Client must promptly provide UL Solutions with written notice that describes the
      deficiency in the Software. § 377 German Commercial Code (Handelsgesetzbuch – HGB) shall,
      where applicable, remain unaffected.
    </p>

    <p>
      Remediation of Defects. To the extent UL Solutions is liable for defects of the Software
      and/or Services in accordance with applicable statutory law, UL Solutions will remedy any
      defects of the Software and/or Services within a reasonable period of time, and in accordance
      with any commitments agreed under the Agreement. Immaterial deviations from the agreed
      specifications shall not constitute a defect. Remediation of defects will be carried out, at
      UL Solutions’ own choice, by either correcting the defect or supplying a non-defective
      replacement of the Software and/or Services. Any remediation of a defect by UL Solutions shall
      not be deemed to constitute any acknowledgement of the defect or acceptance of any legal
      obligation in relation to the defect. If UL Solutions cannot substantially remedy the defect
      of the Software and/or Services in a commercially reasonable manner, Client may terminate the
      affected portion of the Agreement, by cancellation or, as applicable, rescission, in
      accordance with applicable law and Section 13, and will be entitled to a refund as set forth
      in Section 13. Any right of Client to carry out remediation of defects by itself shall be
      excluded. Any claims for damages due to defects of the Software and/or Services are subject to
      the requirements under statutory law and the limitations set forth in Section 10. Any further
      rights of Client in case of defects shall, to the extent permitted by applicable law, be
      excluded.
    </p>

    <p>
      Limitation Period for Claims in case of Defects. Any claims in case of defects of the Software
      and/or Services that are subject to the statute of limitation according to the statutory
      provisions for sales contracts or contracts on the provision of works shall become time-barred
      within twelve (12) months. This limitation shall not apply (i) in case of fraudulently
      concealed defects, or (ii) if any guarantee for the quality of the Software and/or Services
      has been assumed (in this respect, as applicable, the limitation period resulting from the
      guarantee shall apply). In the event of any claims for damages due to defects, this limitation
      shall further not apply in the following cases: (i) damages to life, body or health, (ii)
      intent, and (iii) gross negligence.
    </p>

    <p>
      Except as expressly agreed in writing, UL Solutions is under no obligation to ensure, and does
      not assume any liability, that: (i) the Software and/or Services will be suitable or fit for
      the purposes of compliance with any or all administrative, regulatory, or governmental
      requirements applicable to Client; (ii) Client will obtain any specific results by using the
      Software and/or Services; or (iii) the opinions or findings UL Solutions provides in
      connection with the Software and/or Services will be recognized or accepted by third parties
      or represent legal, medical, or other regulatory advice. Client acknowledges that the Services
      may contain regulatory information and other content provided by third parties and licensed to
      UL Solutions for use in the Services. Client accesses this information at its own risk UL
      Solutions makes no representation or warranties and will have no liability or obligation
      whatsoever in relation to the content or use of any such third-party content.
    </p>

    <p>
      Client Undertakings. Client undertakes that: (i) it and its Affiliates (as the case may be)
      have full power and authority to enter into this MLSA and each Agreement; (ii) it will comply
      with all applicable laws and regulations in the performance of its obligations hereunder;
      (iii) it is authorized under such laws to provide UL Solutions with any Client Content or
      Personal Data that Client makes available and that it has obtained any and all necessary
      consents and licenses and satisfied all other applicable requirements for UL Solutions to use
      such Client Content and process such Personal Data as envisaged under the Agreement; and (iv)
      Client Content does not infringe the IP Rights of any third party.
    </p>

    <p>limitation of liability.</p>

    <p>
      UL Solutions shall be liable for damages in accordance with statutory law in cases of (i)
      intent or (ii) gross negligence.
    </p>

    <p>
      UL Solutions’ liability for damages caused by slight negligence is limited to damages
      resulting from the violation of (i) material obligations the breach of which endangers the
      achievement of the purpose of this Agreement with Client, or (ii) the violation of obligations
      the fulfillment of which is an essential prerequisite for the proper performance of this
      Agreement and on the observance of which Client may rely and regularly relies upon. In these
      cases, UL Solutions’ liability for slight negligence shall be limited to the foreseeable
      damage typical for respective types of contracts. Subject to section 10.6, any further
      liability of UL Solutions in cases of slight negligence shall be excluded.
    </p>

    <p>
      In the cases of section 10.2, (i) UL Solutions’ liability in the aggregate shall be further
      limited to the fees paid to UL Solutions under the applicable Agreement in the twelve (12)
      months preceding the claim, and (ii) UL Solutions shall not be liable for loss of profits.
    </p>

    <p>
      UL Solutions will be liable for any accidental destruction or corruption of Client Content
      only to the extent any damages could not have been prevented by appropriate and regular data
      backup measures on the part of Client. Any liability for accidental destruction or corruption
      of Client Content shall be limited to the amount of reasonable costs of data recovery
      activities that would have been required in case of an appropriate and regular backup of
      Client Content by Client.
    </p>

    <p>
      UL Solutions’ strict liability for any defects existing at the time of conclusion of the
      Agreement (§ 536a BGB) is excluded.
    </p>

    <p>
      The above provisions on limitation of liability shall apply to all claims for damages,
      irrespective of their legal ground, except for claims for damages in case of: (i) damages to
      life, body or health; (ii) fraudulently concealed defects; (iii) the assumption of a guarantee
      (in this respect UL Solutions shall be liable to the extent of the guarantee assumed), or (iv)
      any violation of the German Product Liability Act or other mandatory statutory law.
    </p>

    <p>
      The above limitations of liability shall apply also to any claims for damages against UL
      Solutions’ legal representatives/representative bodies, executive employees, employees,
      representatives or agents.
    </p>

    <p>INDEMNIFICATION.</p>

    <p>
      UL Solutions will defend or settle any causes of action, proceedings, claims, suits, or
      demands brought by a third party (collectively, “Claims”) against Client and its Authorized
      Users (“Client Indemnitees”) to the extent such Claims allege that the Software and/or
      Services, as provided by UL Solutions to Client Indemnities under the Agreement, infringe any
      IP Rights of a third party (“IP Claim”), and will pay any costs, damages, and reasonable
      attorneys’ fees attributable to such claim that are awarded in final judgment against Client
      Indemnitees or are payable in settlement by Client Indemnitees. This indemnity obligation is
      subject to Client notifying UL Solutions within thirty (30) days of becoming aware of the IP
      Claim, granting UL Solutions the authority to defend, compromise, or settle the IP Claim, and
      providing UL Solutions with any information relevant to such IP Claim. UL Solutions will not
      be bound by any settlement or compromise that Client Indemnitees enter into without UL
      Solutions’ prior written consent. UL Solutions will have no liability for any IP Claims that
      are based on (i) Client’s modification of the Software and/or Services in a manner not
      authorized in writing by UL Solutions, (ii) use of the Software and/or Services in a manner
      not permitted by this Agreement, or (iii) use of Client Content alone or in connection with
      the Software and/or Services. If the Software and/or Services, or any portion thereof, are
      found to be infringing, UL Solutions, at its sole option, will have the right to: (a) procure
      for Client the right to continue to use the Software and/or Services; (b) replace the Software
      and/or Services with a non-infringing system; or (c) modify the Software and/or Services so
      that they become non-infringing, provided, however, that if UL Solutions chooses option (b) or
      (c), Client’s intended use of the Software and/or Services is not impaired. Notwithstanding
      the foregoing, if options (a), (b) and (c) are not reasonably available to UL Solutions, then
      UL Solutions may require Client to stop using the affected Software and/or Services and refund
      to Client applicable prepaid fees attributable to the infringing Software and/or Services.
      This Section constitutes UL Solutions’ entire obligation to Client with respect to any IP
      Claim.
    </p>

    <p>
      Client will defend and hold harmless UL Solutions, and its Affiliates and their respective
      parent entities and their directors, officers, employees, agents, and contractors (“UL
      Solutions Indemnitees”) from and against any and all Claims and indemnify the UL Solutions
      Indemnitees for all damages, losses, penalties, judgments, costs, fines, liabilities, and
      expenses of whatever nature, (including reasonable legal fees and expenses) that the UL
      Solutions Indemnitees may incur or suffer in connection with: (i) any Claim that the Client
      Content infringes the IP Rights of any third party; and (ii) any Claims or actions brought by
      third parties arising out of, or related to, Client’s use of the Software and/or Services in a
      manner not permitted by this Agreement, including in connection with Client’s own corporate
      training measures, programs or initiatives.
    </p>

    <p>
      TERM. This MLSA commences on the Effective Date and will remain in effect for 12 months (the
      “initial MLSA term”). Following the expiration of the initial MLSA term, the MLSA will
      automatically renew for successive 12 months terms until either party provides notice to
      terminate the MLSA by cancellation at the end of the then current term. Each Order Form will
      set out the Term (as defined in Section 21.8 below) of the Agreement, including applicable
      renewal Terms. For the avoidance of doubt, the MLSA shall remain in effect for each Agreement
      (i.e., Order Form, Additional Terms and MLSA) until the termination or expiration of all
      applicable Order Forms.
    </p>

    <p>TERMINATION.</p>

    <p>
      Termination Rights. Either party may terminate this MLSA by cancellation, or terminate an
      Agreement by cancellation or, as applicable, rescission, by notice in writing if the other
      party either: (i) commits a material breach of this MLSA or an Agreement and, where capable of
      remedy, fails to remedy such breach within thirty (30) days days of being given written notice
      identifying the breach, requiring it to be remedied and stating that failure to remedy it will
      result in termination under this Section 13; or (ii) ceases productive operations or becomes
      or is declared insolvent or bankrupt, the subject of any proceedings relating to liquidation,
      insolvency, or for the appointment of a receiver or similar officer for it (or to any
      analogous proceedings), makes an assignment for the benefit of all or substantially all of its
      creditors, or enters into an agreement for the composition, extension, or readjustment of all
      or substantially all of its obligations. In addition to the foregoing, and without limiting
      other rights, UL Solutions may cancel this MLSA, or cancel or, as applicable, rescind an
      Agreement, with immediate effect, and without advance notice to Client, in the event Client
      infringes, misappropriates, or violates any UL Solutions IP Rights. Any other right of the
      parties under applicable law to terminate this MLSA or an Agreement for good cause, by
      cancellation or, as applicable, rescission, in whole or in part, shall, except as agreed
      otherwise in the Agreement, remain unaffected. Any cancellation or rescission shall be in
      writing.
    </p>

    <p>
      Termination Consequences. On expiry or termination of the MLSA or any Agreement: (i) the
      rights of each party accrued before such termination will not be affected; (ii) Client’s right
      to use and access the Software and/or Service will immediately cease and Client will promptly
      remove, delete, and uninstall all copies of any Software; and (iii) all payment obligations
      accrued by Client up to the date such termination takes effect will be immediately due and
      payable unless termination is a result of UL Solutions’ uncured breach where, in such case,
      Client will only be obligated to pay fees for Services provided up to the date of termination
      and will be entitled to receive a prorated refund of any unused prepaid fees.
    </p>

    <p>
      GOVERNING LAW. This Agreement is governed by the laws of the Federal Republic of Germany under
      exclusion of the United Nations Convention on Contracts for the International Sale of Goods
      (CISG) and without reference to choice of law principles.
    </p>

    <p>
      DISPUTE RESOLUTION. All disputes, claims, controversies, questions, or differences related to
      or arising out of this Agreement, the Services and/or the Software will be finally settled by
      confidential arbitration (except for the limited court remedies provided below). The
      arbitration will be administered in will be administered in Zurich, Switzerland by the
      International Chamber of Commerce, in accordance with its then-current rules and procedures.
      The arbitration will be conducted in English before a single arbitrator agreed to by both
      parties (or if the parties cannot so agree, an arbitrator appointed by the administrator). The
      arbitrator will apply the governing law and does not have authority to modify this Agreement
      and must apply the choice of law without regard to conflicts of law principles. The
      arbitrator’s decision will be the binding and final remedy for any dispute between the parties
      arising out of this Agreement. However, a party may seek from a court of competent
      jurisdiction: judgment on an arbitration award, provisional remedies in aid of arbitration,
      injunctive relief to stop a breach or threatened breach of this Agreement, or claims regarding
      misappropriation or infringement of IP Rights. In the event a party rejects a written
      financial offer to settle a dispute and ultimately does not receive an arbitration award
      greater than such offer, such party will be responsible for the other party’s reasonable legal
      fees and expenses incurred after presentation of the offer (and, if applicable, such party
      shall not be entitled to recovery of its own legal fees or expenses incurred after its
      rejection of the offer).
    </p>

    <p>
      AUDIT RIGHTS. With thirty (30) days prior written notice, UL Solutions or its designee(s) will
      have the right to reasonably inspect and audit Client’s or a Client Affiliate’s compliance
      with the terms of the Agreement. UL Solutions will perform such audit at UL Solutions’ sole
      cost and expense during regular business hours and in such a manner that does not interfere
      with normal business activities. If an audit reveals that Client’s or a Client Affiliate’s use
      of the Software and/or Services has exceeded the scope of use permitted under the applicable
      Agreement, or Software were not uninstalled or deleted upon termination or expiration in
      accordance with Section 13, UL Solutions may invoice Client or the applicable Affiliate the
      fees for their actual usage of the Services and/or Software. If any audit discloses
      underpayments of three percent (3%) or more of the amount of fees Client or any Affiliate is
      obligated to pay to UL Solutions for their actual usage, the audited party will bear all costs
      incurred by UL Solutions to conduct the audit.
    </p>

    <p>
      FORCE MAJEURE. Neither party will be liable for any delay in performing or for failure to
      perform its obligations (excluding any payment obligations) under this Agreement resulting
      from any cause beyond its reasonable control which by its nature could not have been foreseen
      by such party (or such person), or, if it could have been foreseen, which could not have been
      avoided or prevented by reasonable foresight or planning, including acts of God, riots, fires,
      epidemics, civil unrest, acts of war, acts of terrorism, or failure of energy sources (“Force
      Majeure”). The party claiming benefit of this provision must promptly notify to the other
      party of the Force Majeure and use reasonable efforts to resume performance under this
      Agreement as soon as feasible. Performance times will be considered extended for a period of
      time equivalent to the time lost because of the Force Majeure. If the delays caused by the
      Force Majeure conditions are not cured within thirty (30) days of the Force Majeure event,
      then either party may immediately cancel or, as applicable, rescind an Agreement.
    </p>

    <p>
      Publicity. Except as expressly authorized by UL Solutions in writing, Client will not use the
      name, abbreviation, symbols, trademarks, or service marks, trade names, logos, domain names,
      or corporate identifiers of UL Solutions and its Affiliates (collectively the "Marks").
    </p>

    <p>
      Export Restrictions. Client is advised that the Software and/or Services may be subject to
      access and export controls under United States laws and regulations, including the U.S. Export
      Administration Regulations and Office of Foreign Assets Control regulations, and diversion
      contrary to U.S. law and regulation is prohibited. Client agrees to not directly or indirectly
      access, export, import, or transmit the Software and/or Service from or to any country, end
      user, or for any end use that is prohibited by any applicable U.S. regulation or statute. In
      particular, Client agrees it will not access, export, import, or transmit from or to Cuba,
      Iran, North Korea, Syria, the Donetsk People’s Republic or the Luhansk People’s Republic
      regions, or the Crimea region (collectively, “Sanctioned Countries”) or from or to any party
      set forth on any restricted party list maintained by the United States, or owned or controlled
      by, or acting on behalf of, individuals or entities on such restricted party list, including
      but not limited to the (i) List of Specially Designated Nationals, the Sectoral Sanctions
      Identifications List, and the Foreign Sanctions Evaders List maintained by the U.S. Treasury
      Department’s Office of Foreign Assets Control; and (ii) Denied Persons, Unverified and Entity
      Lists maintained by the U.S. Commerce Department’s Bureau of Industry and Security
      (collectively, “Restricted Party Lists”). Additionally, Client agrees not to directly or
      indirectly access, export, import, transmit, or use the Software and/or Services contrary to
      the laws or regulations of any other governmental entity that has jurisdiction over such
      access, export, import, transmission, or use. Client represents and agrees that it is not
      included on any Restricted Party List maintained by the United States Bureau of Industry and
      Security, Office of Foreign Assets Control, or any other governmental agency and no
      governmental agency has otherwise suspended, revoked, or denied Client’s export privileges.
    </p>

    <p>MISCELLANEOUS.</p>

    <p>
      Relationship of Parties. UL Solutions is an independent contractor and is not an employee,
      partner, joint author, or joint venturer of Client or its Affiliates. The rights and remedies
      under this Agreement may not be enforced by anyone other than the parties hereto.
    </p>

    <p>
      Assignment. Client may not assign or transfer any rights or obligations under this Agreement
      (by operation of law or otherwise) to any other person without UL Solutions written consent.
      UL Solutions may, by providing written notice to Client, assign all of its rights and
      obligations under this Agreement to: (i) an Affiliate, (ii) a purchaser of all or
      substantially all of its stock or assets, or (iii) a third party participating in a merger or
      other corporate reorganization in which the assigning party is a constituent corporation. This
      Agreement will be binding upon and inure to the benefit of the parties and their respective
      successors and permitted assigns.
    </p>

    <p>
      No Waiver. The failure of a party to enforce any right or claim under, or provision of, this
      Agreement will not be deemed to be a waiver of such right, claim, or provision. All waivers
      must be made in writing and signed by the waiving party and any such waiver on one occasion is
      effective only in that instance and only for the purpose that it is given and is not to be
      construed as a waiver on any future occasion.
    </p>

    <p>
      Amendments. This Agreement may not be modified except by way of agreement in writing signed by
      authorized representatives of both parties. This also applies to any waiver of the written
      form requirement.
    </p>

    <p>
      Severability. If any provision of this Agreement is declared or found to be illegal,
      unenforceable, or void, then this shall not affect the validity of the remaining provisions.
      Both parties will be relieved of all obligations arising under any such invalid or
      unenforceable provision.
    </p>

    <p>
      Entire Agreement. This Agreement constitutes the complete and exclusive understanding and
      agreement between the parties, and supersedes any and all prior or contemporaneous agreements,
      communications, or understandings, written or oral, relating to its subject matter. Any
      pre-printed terms and conditions contained or referenced by Client in any purchaser order,
      acceptance, or similar document presented by Client will have no effect, even if UL Solutions
      Contracting Party does not expressly object to them or UL Solutions Contracting Party performs
      a Service without express reservation.
    </p>

    <p>
      Notices. Any notice to Client must be made by hand delivery, courier service, mail, electronic
      mail or facsimile at Client’s principal place of business. Client will provide UL Solutions
      with Client's current contact information and will promptly notify UL Solutions of any
      changes. Any notice to UL Solutions must be made by hand delivery, courier service, electronic
      mail, or U.S. mail c/o UL LLC, Attention: General Counsel, 333 Pfingsten Road, Northbrook,
      Illinois, 60062, U.S.A. Notices will be effective upon receipt. Client shall also provide a
      courtesy copy by email to legal.notices&commat;ul.com.
    </p>

    <p>
      Survival. Upon expiration or termination of the Agreement, the following provisions will
      remain in full force and effect: Sections 4 (Fees, Expenses, and Taxes), 5 (Client
      Responsibilities and Permitted Use), 6 (Intellectual Property and Ownership), 7
      (Confidentiality), 9.1.5 and 9.2 (Undertakings), 10 (Limitation of Liability), 11
      (Indemnification), 12 (Term), 13 (Termination), 14 (Governing Law), 15 (Dispute Resolution),
      16 (Audit Rights), 18 (Publicity), 19 (Export Restrictions), and 20 (Miscellaneous).
    </p>

    <p>
      Counterparts. This Agreement may be executed in counterparts, each of which will be deemed to
      be an original instrument, but all such counterparts together will constitute one and the same
      instrument. Facsimile or electronic transmissions of counterparts displaying facsimile or
      electronic, or electronically reproduced copies, of signatures will be accepted and binding
      with the same force and effect as wet signed originals of the counterpart.
    </p>

    <p>DEFINITIONS.</p>

    <p>
      “Affiliate” means (i) for purposes of UL Solutions, UL Solutions, Inc. and any entity which,
      directly or indirectly, is owned or is controlled by or is under common ownership or control
      with UL Solutions Inc., and (ii) for purposes of Client, an entity which, directly or
      indirectly, owns or controls, is owned or is controlled by or is under common ownership or
      control with such Client; where “control” means the power to direct the management or affairs
      of an entity, and “ownership” means the beneficial ownership of greater than fifty percent
      (50%) of the voting equity securities or other equivalent voting interests of the entity.
    </p>

    <p>
      “Authorized User” means (i) a full-time or part-time employee of Client (or a
      contract/temporary employee working for Client for the purpose of assisting Client in its
      day-to-day business activities) who is authorized by Client to access and use the Software or
      Services, or (ii) other mutually agreed categories of users identified in accordance with
      Section 2, provided that competitors of UL Solutions may not be Authorized Users. An
      Authorized User does not acquire individual rights in the Software or Services other than the
      right to access and use such Software or Services on Client’s behalf and pursuant to the
      rights granted to Client and subject to the terms and conditions of this Agreement.
    </p>

    <p>
      “IP Rights” means copyrights and related rights of use, database rights, trademarks, service
      marks, certification marks, designs, patents, know how, trade and business secrets, or other
      intellectual and industrial property rights arising or enforceable under applicable law.
    </p>

    <p>
      “Order Form” means any mutually agreed order form, statement of work, quotation or other
      document provided by UL Solutions to Client, which describes the Services and/or Software to
      be provided by UL Solutions and the related fees for such Services and/or Software.
    </p>

    <p>
      "Services" means the software as a service (“SaaS”) or managed hosting services, including any
      related services, that are identified in an Order Form, including implementation services,
      Support Services, and the provision of related documentation, graphics, designs, reports, and
      information.
    </p>

    <p>
      “Software” means the application or other computer program, in object code, identified in an
      Order Form that is licensed to Client, including documentation and related graphics, designs,
      reports, and information, and all updates, upgrades, and enhancements that UL Solutions
      provides as part of any applicable Support Services.
    </p>

    <p>
      “Support Services” (i) with respect to Software means UL Solutions’ standard support and
      maintenance for the Software that UL Solutions makes available to Customers as set forth in an
      Order Form and as described in separate support terms attached to, or incorporated by
      reference into, such Order Form; and (ii) with respect to SaaS means the telephone support,
      online documentation, email or web-based portal support as identified in an Order Form and as
      described in separate support terms attached to, or incorporated by reference into, such Order
      Form.
    </p>

    <p>
      “Term” means the period of time that UL Solutions will make the Services available to Client
      and/or license the Software to Client as set forth in the applicable Order Form.
    </p>

    <p>
      The parties have caused their duly authorized representatives to execute and enter into this
      MLSA as of the Effective Date.
    </p>
    <p></p>

    <p>Exhibit A</p>

    <p>Personal Data Processor Terms</p>

    <p>1. DEFINITIONS.</p>

    <p>
      1.1. "Controller" means the entity that, alone or jointly with others, determines the purposes
      and means of the Processing of Personal Data.
    </p>

    <p>
      1.2. “Data Protection Legislation” means the applicable laws and regulations (including
      decisions, codes of practice, and guidance from competent institutions supervising or
      regulating data protection), in each case, relating to the Processing of Personal Data and
      privacy; including where applicable, (i) the General Data Protection Regulation (EU) 2016/679
      (“GDPR”) and national data protection laws in the European Union (“EU”) and the European
      Economic Area (“EEA”), and the data protection laws of Switzerland and of the United Kingdom
      (including the Privacy and Electronic Communications (EC Directive) Regulations 2003, UK Data
      Protection Act 2018 and the UK GDPR) (collectively “European Data Protection Laws”), (ii) the
      People's Republic of China ("PRC") Personal Information Protection Law, and its implementing
      regulations and measures ("PIPL"), and/or (iii) the California Consumer Privacy Act (Cal. Civ.
      Code 1798.100-1798.199) (“CCPA”), in each case, as may be amended from time to time.
    </p>

    <p>1.3 “Data Subject” means an identified or identifiable natural person.</p>

    <p>
      1.4. “Personal Data” means information that identifies, relates to, describes, is reasonably
      capable of being associated with, or could reasonably be linked, directly or indirectly, with
      a Data Subject. “Personal Data” includes personal information and personal data (as those
      terms are defined in the applicable Data Protection Legislation), as context requires.
    </p>

    <p>
      1.5. “Process”, “Processed” or “Processing” means any operation or set of operations which is
      performed on Personal Data or on sets of Personal Data, whether or not by automated means,
      such as collection, recording, organization, structuring, storage, adaptation or alteration,
      retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making
      available, alignment or combination, restriction, erasure, or destruction.
    </p>

    <p>
      1.6. “Processor” means the entity that Processes Personal Data on behalf of the Controller.
    </p>

    <p>
      2. AUTHORITY. These Personal Data Processing Terms apply to Personal Data that Client enters
      into, or submits to, the Services or Software and that UL Solutions Processes on behalf of
      Client. Client authorizes UL Solutions to Process such Personal Data during the term of the
      Agreement as a Processor (on Client's and, as applicable, its Affiliates behalf as
      Controller(s)) for the purposes of providing the Services, as further specified in the
      Agreement and this Exhibit.
    </p>

    <p>
      3. COMPLIANCE WITH DATA PROTECTION LEGISLATION. UL Solutions will comply with Data Protection
      Legislation applicable to UL Solutions in providing the Services and will not knowingly cause
      Client to breach any obligation under the Data Protection Legislation. UL Solutions will
      immediately inform the Controller if, in its opinion, an instruction infringes the Data
      Protection Legislation.
    </p>

    <p>
      4. SUB-PROCESSING. Client acknowledges and agrees that, in relation to Processing of Personal
      Data in connection with the provision of the applicable Software or Services, (a) UL Solutions
      Affiliates may be retained as subcontractors; and (b) UL Solutions and UL Solutions
      Affiliates, respectively, may engage third-party service providers in connection with
      provision of the Services, (each a "Sub-Processor"). UL Solutions has entered into a written
      agreement with each Sub-Processor containing data protection obligations no less protective
      than those in this Exhibit A with respect to the protection of Personal Data to the extent
      applicable to the nature of the services provided by such Sub-Processor. UL Solutions will
      remain responsible for all acts or omissions of the Sub-Processor as if they were its own.
    </p>

    <p>
      UL Solutions will make available to Client the current list of Sub-Processors for the
      Services. Such Sub-Processor list will include the identities of those Sub-Processors and
      their country of location. The current list is available at the following UL Solutions site:
      https://www.ul.com/resources/gdpr-compliance (the “Data Protection Site”). Client specifically
      agrees that UL Solutions may retain the Sub-Processors listed at the Data Protection Site. The
      Data Protection Site has a mechanism for Client to subscribe to notifications of new
      Sub-Processors for each applicable Service, and if Client subscribes, UL Solutions will
      provide reasonable advance notification of new Sub-Processor(s) before authorizing any new
      Sub-Processor(s) to Process Personal Data in connection with provision of the applicable
      Services. Client's non-subscription to the notifications will be deemed as approval of current
      and subsequent Sub-Processors listed on the Data Protection Site.
    </p>

    <p>
      Client may object to UL Solutions’ use of a new Sub-Processor by notifying UL Solutions at
      privacy&commat;ul.com in writing within ten (10) business days after receipt of UL Solutions’
      notice in accordance with the mechanism set out above. If no objection is raised in writing
      within said period, the new Sub-Processor will be deemed as approved by Client. In the event
      Client objects to a new Sub-Processor, as permitted in the preceding sentence, UL Solutions
      will use reasonable efforts to make available to Client a change in the Services or Client’s
      use of the Services to avoid Processing of Personal Data by the objected-to new Sub-Processor.
      If UL Solutions is unable to make available such change within a reasonable period of time,
      which will not exceed thirty (30) days, Client may terminate the applicable Agreement with
      respect only to those Services that cannot be provided by UL Solutions without use of the
      objected-to new Sub-Processor by providing written notice to UL Solutions.
    </p>

    <p>
      5. UL SOLUTIONS OBLIGATIONS. UL Solutions will (and will procure that any authorized
      Sub-Processor will):
    </p>

    <p>
      5.1. Process Personal Data only on documented instructions from Client to the extent required
      to provide the Services., including technical operation and maintenance, security, and
      customer support, unless required to do so by laws applicable to UL Solutions; in such a case,
      UL Solutions will to the extent permitted inform Client of that legal requirement before
      Processing. The Agreement shall be considered documented instructions for UL Solutions to
      Process Personal Data as needed to provide the Services. For the avoidance of doubt, Client
      agrees and authorizes UL Solutions to aggregate and anonymize Personal Data, and Process such
      Aggregated Data to support and improve UL Solutions’ products and services, as further set out
      the Agreement.
    </p>

    <p>
      5.2. require any person authorized to Process Personal Data: (a) to be under appropriate
      contractual confidentiality obligations or an appropriate statutory obligation of
      confidentiality; (b) to Process the Personal Data on instructions from Client; and (c) to be
      appropriately qualified and trained in relation to their Processing of Personal Data;
    </p>

    <p>
      5.3. implement and maintain technical, physical, and organizational security measures
      appropriate to the risk presented by Processing Personal Data and that are designed to protect
      and safeguard Personal Data, including those security measures that are described in the Order
      Form and/or Additional Terms;
    </p>

    <p>
      5.4. notify Client in accordance with applicable Data Protection Legislation without undue
      delay after becoming aware of any Security Incident and reasonably assist Client in complying
      with its obligations in relation to reporting any Security Incident to any regulatory or
      supervisory authority, or Data Subject, taking into account the nature of the Processing and
      the information available to UL Solutions. For purposes of this Agreement, Security Incident
      means a personal data breach as such term is defined by applicable Data Protection
      Legislation, or when not defined by applicable Data Protection Legislation, the unauthorized
      access to, or acquisition of, Personal Data that compromises the security or confidentiality
      of such Personal Data. Where, and in so far as, it is not possible to provide the information
      at the same time, the information may be provided in phases without undue further delay; and
    </p>

    <p>
      5.5. provide reasonable assistance to Client in: (a) responding to requests of a Data Subject
      for exercising his/her rights under applicable Data Protection Legislation, including, as
      applicable, by deleting Personal Data, correcting Personal Data, disclosing the specific
      pieces of Personal Data Processed by UL Solutions, insofar as reasonable; and (b), taking into
      account the nature of the Processing and the information available to UL Solutions, conducting
      data protection impact assessments and, as applicable, any prior consultation with the
      supervisory authority.
    </p>

    <p>
      5.6. delete, or return upon request, all Personal Data to Client in accordance with Section
      7.3 of the MLSA.
    </p>

    <p>
      6. INTERNATIONAL TRANSFERS. Without limiting the foregoing, UL Solutions and Client may enter
      into any additional agreements concerning the cross-border transfer of Personal Data as may be
      required by applicable Data Protection Legislation, including, if applicable, the Standard
      Contractual Clauses set out in Commission Implementing Decision (EU) 2021/914 of 4 June 2021
      (as may be amended or superseded from time to time) or any other model agreements that may be
      required under applicable Data Protection Legislation.
    </p>

    <p>
      7. ADDITIONAL CCPA COMPLIANCE. Without limiting the foregoing, UL Solutions will not (i) sell
      or otherwise make available Personal Data to a third party for monetary or other valuable
      consideration, or (ii) share or otherwise make available Personal Data to a third party for
      cross-context behavioral advertising, whether or not for monetary or other valuable
      consideration. In addition, UL Solutions will not combine Personal Data that UL Solutions
      receives from, or on behalf of, Client with personal information that UL Solutions receives
      from, or on behalf of, another person or persons, or collects from its own interaction with
      the Data Subject, provided that UL Solutions may combine personal information to perform any
      business purpose as permitted by CCPA.
    </p>

    <p>
      8. AUDITS. UL Solutions will make available to Client information to demonstrate compliance
      with the obligations set forth in this Exhibit (Personal Data Processor Terms) and allow for
      and contribute to audits as required by applicable Data Protection Legislation. Such audits or
      inspections will be conducted by Client or a mutually agreed third party auditor selected by
      Client and occur no more than once annually. Client will reimburse UL Solutions for any time
      expended for any audit at UL Solutions’ current professional services rates, which UL
      Solutions will make available to Client upon request. Before the commencement of any such
      audit, Client and UL Solutions will mutually agree upon the timing, scope, and duration of the
      audit in addition to the reimbursement rate for which Client will be responsible. All
      reimbursement rates will be reasonable, taking into account the resources expended by UL
      Solutions.
    </p>
  </div>
  <p>
    If you accept the terms of the agreement, click Accept to continue. You must accept the
    agreement to use CRA Companion.
  </p>
  <form class="ul-form" (ngSubmit)="onSubmit()">
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button type="button" comp-button="secondary" (click)="onDecline()">
          {{ 'general.decline' | translate }}
        </button>
        <button comp-button type="submit">
          {{ 'general.accept' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons>
  </form>
</article>
